import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Forgot() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/auth/forgot-password", { email }); setSent(true); }
    catch (e2) { setErr(formatApiErr(e2.response?.data?.detail)); }
  };
  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--bg-app)] p-6">
      <form onSubmit={submit} className="w-full max-w-md bg-white border rounded-xl p-8" data-testid="forgot-form">
        <h2 className="text-2xl font-semibold mb-2">Forgot password</h2>
        {sent ? (
          <p className="text-sm text-zinc-600">If an account exists we&apos;ve sent reset instructions. (Dev: check backend logs)</p>
        ) : (
          <>
            <p className="text-sm text-zinc-500 mb-4">Enter your work email.</p>
            <Label>Email</Label>
            <Input value={email} onChange={(e) => setEmail(e.target.value)} type="email" required data-testid="forgot-email"/>
            {err && <div className="text-sm text-red-600 mt-2">{err}</div>}
            <Button className="w-full mt-4 bg-[var(--brand-primary)] text-white" type="submit" data-testid="forgot-submit">Send reset link</Button>
          </>
        )}
        <div className="text-sm text-center mt-4"><Link to="/login" className="text-[var(--brand-accent)]">Back to sign in</Link></div>
      </form>
    </div>
  );
}
